// extracted by mini-css-extract-plugin
module.exports = {"container":"home_container__2BZuO","main":"home_main__3XoC5","creator":"home_creator__14iNr","btnCreate":"home_btnCreate__dhF8Z"};